import { render, staticRenderFns } from "./LoginCopyright.vue?vue&type=template&id=1ed5be09&scoped=true&"
import script from "./LoginCopyright.vue?vue&type=script&lang=js&"
export * from "./LoginCopyright.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed5be09",
  null
  
)

export default component.exports